var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 9L12 12L16 9","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M3 16.2857V7.71429C3 6.76751 3.80589 6 4.8 6H19.2C20.1941 6 21 6.76751 21 7.71429V16.2857C21 17.2325 20.1941 18 19.2 18H4.8C3.80589 18 3 17.2325 3 16.2857Z","stroke":"currentColor","strokeWidth":"1.5","key":1})]);
}

Mail.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","color":"currentColor"};

module.exports = Mail;

Mail.default = Mail;
